import { z } from "zod";

export const apiKeyFormSchema = z
  .object({
    name: z.string().min(1, { message: "This field is required" }),
    permissions: z
      .string()
      .array()
      .min(1, { message: "This field is required" }),
    allowedIPs: z
      .array(z.string().min(1, { message: "This field is required" }))
      .optional(),
    noLimitIp: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.noLimitIp && (!data.allowedIPs || data.allowedIPs.length === 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "At least one IP address is required",
        path: ["allowedIPs"],
      });
    }
  });

export type IApiKeyForm = z.infer<typeof apiKeyFormSchema>;
